module.exports = __webpack_public_path__ + "static/media/inf_07og08.c4df60f1.mp3";